export var PlatformName = function (platform) {
    switch (platform) {
        case 'amazon':
            return 'Amazon Fire OS';
        case 'android':
            return 'Android';
        case 'brightsign':
            return 'BrightSign';
        case 'browser':
            return 'Browser';
        case 'chromeos':
            return 'Chrome OS';
        case 'ios':
            return 'iOS';
        case 'ipados':
            return 'iPadOS';
        case 'osx':
        case 'mac':
            return 'macOS';
        default:
            return 'Unknown';
        case 'windows':
            return 'Windows';
    }
};
//# sourceMappingURL=index.js.map